var map = {
	"./01car.svg": 67536,
	"./14excavator.svg": 38947,
	"./arrow.svg": 4350,
	"./bicycle.svg": 53346,
	"./bus.svg": 56375,
	"./businesscar.svg": 97549,
	"./car.svg": 47543,
	"./excavator.svg": 33942,
	"./excavator2.svg": 69816,
	"./logo.svg": 73242,
	"./motorbike.svg": 51569,
	"./motorcycle.svg": 99024,
	"./plain.svg": 80961,
	"./ship.svg": 99345,
	"./suv.svg": 18079,
	"./trackplayback.svg": 62827,
	"./transportmixer.svg": 92029,
	"./truck.svg": 41732,
	"./untitled.svg": 37844,
	"./van.svg": 16938,
	"./videomonitor.svg": 38618,
	"./videoplayback.svg": 91763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30279;